import React, { useState,useEffect } from 'react';
import { Award, Mail, Phone, MapPin, Clock, Shield, FileText, CheckCircle, X } from 'lucide-react';
import emailjs from '@emailjs/browser';
import LogoTop from '../assets/images/logoValterTopografia.png';
import MarcaHero from '../assets/images/marca1.jpg';

// Configuração do EmailJS
const EMAILJS_SERVICE_ID = 'service_85lnr5d';
const EMAILJS_TEMPLATE_ID = 'template_vdqcbfv';
const EMAILJS_PUBLIC_KEY = '9JinXn_LhRclyCxjT';
const WhatsAppIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.63"/>
  </svg>
);

const FacebookIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

// Inicializar EmailJS apenas se as chaves estiverem disponíveis
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

const newWhatsApp = (phoneNumber = "5524999324268", message = "Olá! Gostaria de agendar uma reunião.") => {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  window.open(whatsappUrl, '_blank');
};

// Componente Header
const Header = () => {
  return (
    <header className="py-4">
      <div className="container">
        <div className="text-center">
          {/* Logo */}
          <div className="mb-4">
            <img 
              src={LogoTop}
              alt="Valter Topógrafo Logo" 
              className="logo-header"
              style={{
                maxWidth: '120px',
                height: 'auto',
                filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <h1 className="h2 fw-bold text-warning mb-1">VALTER TOPÓGRAFO</h1>
          <p className="small mb-1" style={{opacity: 0.9}}>TOPOGRAFIA E GEOREFERENCIAMENTO</p>
          <p className="small" style={{opacity: 0.75}}>MEDINDO, PROJETANDO E CONSTRUINDO SEUS SONHOS</p>
        </div>
      </div>
    </header>
  );
};

// Componente Hero Section
const HeroSection = ({ onOpenModal }) => {
  return (
    <section 
      className="py-5 position-relative"
      style={{
        backgroundImage: `url(${MarcaHero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay para melhorar legibilidade do texto */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: 'rgba(0, 128, 0, 0.5)',
          zIndex: 1
        }}
      ></div>
      
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <h2 className="display-4 fw-bold mb-4 lh-base">
              Você já parou pra pensar como seria sua vida se seu imóvel estivesse 
              <span className="text-warning"> REGULARIZADO?</span>
            </h2>
            <p className="h4 mb-4" style={{opacity: 0.9}}>
              Imagine você com sua <strong>escritura em mãos!</strong>
            </p>
            <p className="h6 mb-4">
              Quantas oportunidades está perdendo por não ter esse documento? 
              Através de uma <strong className="text-warning">análise gratuita</strong> posso te ajudar.
            </p>
            <div className="alert alert-danger fw-bold mb-4">
              <div className="d-flex align-items-center justify-content-center">
                <span className="me-2">⚠️</span>
                ATENÇÃO: Restam poucas vagas para análise gratuita!
              </div>
            </div>
            {/* <button 
              onClick={onOpenModal}
              className="btn btn-warning btn-lg px-5 py-3 fw-bold text-dark rounded-pill shadow btn-pulse"
              style={{fontSize: '1.2rem'}}
              type="button"
            >
              QUERO MINHA ANÁLISE GRATUITA
            </button> */}
             <button 
              onClick={() => newWhatsApp("5524999324268", "Olá! Gostaria de solicitar minha análise gratuita para regularização do meu imóvel.")}
              className="btn btn-warning btn-lg px-5 py-3 fw-bold text-dark rounded-pill shadow btn-pulse"
              style={{fontSize: '1.2rem'}}
              type="button"
            >
              QUERO MINHA ANÁLISE GRATUITA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Problem Section
const ProblemSection = ({ onOpenModal }) => {
  return (
    <section className="py-5 bg-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <h3 className="h2 fw-bold mb-5">
              Já imaginou como seria bem mais <span className="text-warning">SEGURO</span> se você estivesse com a Certificação?
            </h3>
            <div className="row g-4 mb-5">
              <div className="col-md-4">
                <div className="card card-custom h-100">
                  <div className="card-body text-center p-4">
                    <FileText className="mx-auto mb-3 text-warning" size={48} />
                    <h4 className="fw-bold mb-2">CCIR</h4>
                    <p className="mb-0">Certificado de Cadastro de Imóvel Rural</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card card-custom h-100">
                  <div className="card-body text-center p-4">
                    <Shield className="mx-auto mb-3 text-warning" size={48} />
                    <h4 className="fw-bold mb-2">ITR</h4>
                    <p className="mb-0">Imposto Territorial Rural</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card card-custom h-100">
                  <div className="card-body text-center p-4">
                    <Award className="mx-auto mb-3 text-warning" size={48} />
                    <h4 className="fw-bold mb-2">CAR</h4>
                    <p className="mb-0">Cadastro Ambiental Rural</p>
                  </div>
                </div>
              </div>
            </div>
            <p className="h6 mb-4">
              Você teria um <strong>leque de oportunidades</strong> com seu imóvel legalizado, 
              sem contar a <span className="text-warning">segurança e tranquilidade</span> que sua família terá.
            </p>
            <div className="alert alert-warning text-dark">
              <div className="d-flex align-items-center justify-content-center">
                <Clock className="me-2" size={24} />
                <strong>Temos uma equipe esperando para fazer uma análise gratuita para você. Mas corra, é por tempo limitado!</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Solution Section
const SolutionSection = () => {
  const services = [
    'Usucapião Judicial e Extrajudicial',
    'REURB',
    'Inventário',
    'Partilha',
    'Estremação',
    'Outras formas legais'
  ];

  return (
    <section className="py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h3 className="h2 fw-bold text-center mb-5">
              Legalização de Imóvel <span className="text-warning">Urbano e Rural</span>
            </h3>
            <div className="card card-custom">
              <div className="card-body p-5">
                <p className="h6 mb-4">
                  Se você tem um imóvel e ainda não possui sua escritura e registro de imóvel, podemos te ajudar através de:
                </p>
                <div className="row g-3">
                  {services.map((service, index) => (
                    <div key={index} className="col-md-6">
                      <div className="d-flex align-items-center">
                        <CheckCircle className="text-warning me-3 flex-shrink-0" size={20} />
                        <span>{service}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Authority Section
const AuthoritySection = () => {
  return (
    <section className="py-5 bg-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <h3 className="h2 fw-bold mb-5">
              <Award className="me-3 text-warning" size={40} />
              Nossa <span className="text-warning">Expertise</span>
            </h3>
            <p className="h6 mb-5">
              Se você precisa realizar um levantamento topográfico geo-referenciado, 
              conferir o tamanho do seu lote, demarcar uma área, locação de uma obra e gabarito, podemos te ajudar:
            </p>
            <div className="card card-custom">
              <div className="card-body p-4">
                <p className="h5 fw-semibold mb-0">
                  Somos uma empresa de topografia e geo-referenciamento com 
                  <span className="text-warning"> muita experiência</span> e vamos dar um norte à sua obra.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Scarcity Section
const ScarcitySection = ({ onOpenModal }) => {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="alert alert-danger mb-5">
              <h3 className="h3 fw-bold mb-3">⏰ OFERTA POR TEMPO LIMITADO!</h3>
              <p className="h6 mb-0">
                Clique no botão abaixo! Iremos analisar gratuitamente a melhor forma para resolver 
                e trazer a <strong>segurança e tranquilidade</strong> que sua família merece.
              </p>
            </div>
            <button 
              onClick={() => newWhatsApp("5524999324268", "Olá! Gostaria de solicitar minha análise gratuita para regularização do meu imóvel.")}
              className="btn btn-warning btn-lg px-5 py-3 fw-bold text-dark rounded-pill shadow btn-pulse"
              style={{fontSize: '1.2rem'}}
              type="button"
            >
              GARANTIR MINHA VAGA AGORA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Objection Section
const ObjectionSection = () => {
  const benefits = [
    { icon: '💰', title: 'PAGAR MENOS JUROS', description: 'Na aquisição de financiamentos' },
    { icon: '🚗', title: 'FINANCIAR VEÍCULOS', description: 'Carros e motos com melhores condições' },
    { icon: '💳', title: 'EMPRÉSTIMOS', description: 'Para fazer o que bem entender' }
  ];

  return (
    <section className="py-5 bg-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <h3 className="h2 fw-bold mb-5">
              Você sabia que com seu imóvel <span className="text-warning">REGULARIZADO</span> você poderia:
            </h3>
            <div className="row g-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="col-md-4">
                  <div className="card card-custom h-100">
                    <div className="card-body p-4">
                      <h4 className="fw-bold text-warning mb-2">
                        {benefit.icon} {benefit.title}
                      </h4>
                      <p className="mb-0">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente Footer
// const Footer = () => {
//   return (
//     <footer className="py-4 bg-footer">
//       <div className="container text-center">
//         <h3 className="h5 fw-bold text-warning mb-2">VALTER TOPÓGRAFO</h3>
//         <p style={{opacity: 0.75}}>Medindo, projetando e construindo seus sonhos</p>
//         <div className="d-flex justify-content-center gap-4 mt-3">
//           <Phone size={20} className="icon-hover" />
//           <Mail size={20} className="icon-hover" />
//           <MapPin size={20} className="icon-hover" />
//         </div>
//       </div>
//     </footer>
//   );
// };
const Footer = () => {
  // URLs das suas redes sociais (substitua pelos seus links reais)
  const socialLinks = {
    whatsapp: "https://wa.me/5524999324268", 
    facebook: "https://facebook.com/Valter.Machado.131180", 
    instagram: "https://instagram.com/valtertopografo", 
    website: "https://valtertopografo.com.br" 
  };

  return (
    <footer className="py-4 bg-footer">
      <div className="container text-center">
        <h3 className="h5 fw-bold text-warning mb-2">VALTER TOPÓGRAFO</h3>
        <p style={{opacity: 0.75}}>Medindo, projetando e construindo seus sonhos</p>
        
        {/* Links das Redes Sociais */}
        <div className="d-flex justify-content-center gap-3 mt-3 mb-3">
          <a 
            href={socialLinks.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="text-success icon-hover d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: 'rgba(37, 211, 102, 0.1)',
              transition: 'all 0.3s ease'
            }}
            title="WhatsApp"
          >
            <WhatsAppIcon size={24} />
          </a>
          
          <a 
            href={socialLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary icon-hover d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: 'rgba(24, 119, 242, 0.1)',
              transition: 'all 0.3s ease'
            }}
            title="Facebook"
          >
            <FacebookIcon size={24} />
          </a>
          
          <a 
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-hover d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'linear-gradient(45deg, #e1306c, #fd1d1d, #fcb045)',
              color: 'white',
              transition: 'all 0.3s ease'
            }}
            title="Instagram"
          >
            <InstagramIcon size={24} />
          </a>
        </div>

        {/* Copyright e Link do Site */}
        <div className="border-top pt-3 mt-3" style={{borderColor: 'rgba(255,255,255,0.1) !important'}}>
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
            <small style={{opacity: 0.7}}>
              © 2025 Valter Topógrafo. Todos os direitos reservados.
            </small>
            <span className="d-none d-md-inline" style={{opacity: 0.5}}>|</span>
            <small>
              <a 
                href={socialLinks.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-warning text-decoration-none"
                style={{transition: 'opacity 0.3s ease'}}
              >
                www.valtertopografo.com.br
              </a>
            </small>
          </div>
          
          {/* Créditos da Agência */}
          <div className="mt-2">
            <small style={{opacity: 0.6}}>
              Desenvolvido por{' '}
              <a 
                href="https://agenciaabup.com.br/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-warning text-decoration-none"
                style={{fontWeight: '500'}}
              >
                Agencia Abup
              </a>
            </small>
          </div>
        </div>
      </div>

      <style jsx>{`
        .icon-hover:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        .icon-hover {
          transition: all 0.3s ease;
        }
        
        a.text-warning:hover {
          opacity: 0.8;
        }
      `}</style>
    </footer>
  );
};

const WhatsAppFloat = ({ 
  phoneNumber = "5524999324268", 
  message = "Olá! Gostaria de agendar um reunião.",
  position = "bottom-right" 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Mostrar o botão após a página carregar
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Função para abrir o WhatsApp
  const openWhatsApp = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  // Definir posicionamento baseado na prop
  const getPositionStyles = () => {
    const baseStyles = {
      position: 'fixed',
      zIndex: 9999,
    };

    switch (position) {
      case 'bottom-left':
        return { ...baseStyles, bottom: '20px', left: '20px' };
      case 'top-right':
        return { ...baseStyles, top: '20px', right: '20px' };
      case 'top-left':
        return { ...baseStyles, top: '20px', left: '20px' };
      default: // bottom-right
        return { ...baseStyles, bottom: '20px', right: '20px' };
    }
  };

  return (
    <>
      {/* Botão WhatsApp */}
      <div
        style={{
          ...getPositionStyles(),
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1)' : 'scale(0)',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <button
          onClick={openWhatsApp}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="btn btn-success rounded-circle shadow-lg border-0 position-relative"
          style={{
            width: '60px',
            height: '60px',
            background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)',
            transform: isHovered ? 'scale(1.1)' : 'scale(1)',
            transition: 'all 0.3s ease',
            animation: 'pulse 2s infinite',
          }}
          title="Fale conosco no WhatsApp"
        >
          {/* Ícone do WhatsApp */}
          <svg 
            width="28" 
            height="28" 
            viewBox="0 0 24 24" 
            fill="white"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.63"/>
          </svg>

          {/* Indicador de notificação */}
          <span
            className="position-absolute bg-danger rounded-circle"
            style={{
              width: '16px',
              height: '16px',
              top: '2px',
              right: '2px',
              animation: 'notification-pulse 1.5s infinite',
            }}
          />
        </button>

        {/* Tooltip/Mensagem */}
        {isHovered && (
          <div
            className="position-absolute bg-dark text-white px-3 py-2 rounded shadow"
            style={{
              bottom: '70px',
              right: '0',
              whiteSpace: 'nowrap',
              fontSize: '14px',
              animation: 'fadeInUp 0.3s ease',
              maxWidth: '200px',
              whiteSpace: 'normal'
            }}
          >
            <div className="fw-bold mb-1">💬 Fale Conosco!</div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              Clique para conversar no WhatsApp
            </div>
            {/* Seta do tooltip */}
            <div
              style={{
                position: 'absolute',
                bottom: '-5px',
                right: '20px',
                width: '0',
                height: '0',
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: '5px solid #343a40'
              }}
            />
          </div>
        )}
      </div>

      {/* Estilos CSS */}
      <style jsx>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }

        @keyframes notification-pulse {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.7;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Responsividade para mobile */
        @media (max-width: 768px) {
          .whatsapp-float {
            bottom: 15px !important;
            right: 15px !important;
          }
          
          .whatsapp-float button {
            width: 55px !important;
            height: 55px !important;
          }
          
          .whatsapp-float svg {
            width: 24px !important;
            height: 24px !important;
          }
        }
      `}</style>
    </>
  );
};

// Função de validação de email
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Função de validação de telefone
const isValidPhone = (phone) => {
  const phoneRegex = /^[\d\s\-\(\)\+]{10,}$/;
  return phoneRegex.test(phone);
};

// Componente Modal
const Modal = ({ show, onClose, formData, onInputChange, onSubmit, isLoading }) => {
  if (!show) return null;

  const isFormValid = 
    formData.nome && 
    formData.email && 
    isValidEmail(formData.email) &&
    formData.telefone && 
    isValidPhone(formData.telefone) &&
    formData.tipoImovel && 
    formData.situacao;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Análise Gratuita</h3>
          <button 
            className="btn-close-custom" 
            onClick={onClose}
            type="button"
            aria-label="Fechar modal"
            disabled={isLoading}
          >
            <X size={24} />
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Nome Completo *</label>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={onInputChange}
                  className="form-control form-control-custom"
                  required
                  disabled={isLoading}
                  maxLength={100}
                />
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={onInputChange}
                  className={`form-control form-control-custom ${
                    formData.email && !isValidEmail(formData.email) ? 'is-invalid' : ''
                  }`}
                  required
                  disabled={isLoading}
                  maxLength={100}
                />
                {formData.email && !isValidEmail(formData.email) && (
                  <div className="invalid-feedback">
                    Por favor, insira um email válido.
                  </div>
                )}
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Telefone/WhatsApp *</label>
                <input
                  type="tel"
                  name="telefone"
                  value={formData.telefone}
                  onChange={onInputChange}
                  className={`form-control form-control-custom ${
                    formData.telefone && !isValidPhone(formData.telefone) ? 'is-invalid' : ''
                  }`}
                  required
                  disabled={isLoading}
                  maxLength={20}
                  placeholder="(11) 99999-9999"
                />
                {formData.telefone && !isValidPhone(formData.telefone) && (
                  <div className="invalid-feedback">
                    Por favor, insira um telefone válido.
                  </div>
                )}
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Tipo de Imóvel *</label>
                <select
                  name="tipoImovel"
                  value={formData.tipoImovel}
                  onChange={onInputChange}
                  className="form-control form-control-custom"
                  required
                  disabled={isLoading}
                >
                  <option value="">Selecione...</option>
                  <option value="urbano">Urbano</option>
                  <option value="rural">Rural</option>
                  <option value="comercial">Comercial</option>
                </select>
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Situação Atual *</label>
                <select
                  name="situacao"
                  value={formData.situacao}
                  onChange={onInputChange}
                  className="form-control form-control-custom"
                  required
                  disabled={isLoading}
                >
                  <option value="">Selecione...</option>
                  <option value="sem_escritura">Sem escritura</option>
                  <option value="irregularidades">Com irregularidades</option>
                  <option value="levantamento">Preciso de levantamento</option>
                  <option value="regularizacao">Regularização completa</option>
                </select>
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold text-dark">Mensagem</label>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={onInputChange}
                  className="form-control form-control-custom"
                  rows="3"
                  placeholder="Conte-nos mais sobre sua necessidade..."
                  disabled={isLoading}
                  maxLength={500}
                />
              </div>
              
              <div className="col-12 mt-4">
                <button
                  onClick={onSubmit}
                  disabled={!isFormValid || isLoading}
                  className={`btn w-100 fw-bold py-3 ${isFormValid && !isLoading ? 'btn-submit' : 'btn-disabled'}`}
                  style={{
                    fontSize: '1.1rem',
                    color: 'white',
                    backgroundColor: isFormValid && !isLoading ? '#0f766e' : '#9ca3af',
                    border: 'none',
                    borderRadius: '0.75rem'
                  }}
                  type="button"
                >
                  {isLoading ? 'Enviando...' : 'SOLICITAR ANÁLISE GRATUITA'}
                </button>
              </div>
            </div>
          </form>
          
          <p className="small text-muted mt-3 text-center">
            Seus dados estão seguros conosco. Não compartilhamos com terceiros.
          </p>
        </div>
      </div>
    </div>
  );
};

// Componente Principal
const LandingPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    tipoImovel: '',
    situacao: '',
    mensagem: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      nome: '',
      email: '',
      telefone: '',
      tipoImovel: '',
      situacao: '',
      mensagem: ''
    });
  };

  const handleSubmit = async () => {
    // Validações finais
    if (!formData.nome?.trim() || 
        !formData.email?.trim() || 
        !isValidEmail(formData.email) ||
        !formData.telefone?.trim() || 
        !isValidPhone(formData.telefone) ||
        !formData.tipoImovel || 
        !formData.situacao) {
      alert('Por favor, preencha todos os campos obrigatórios corretamente.');
      return;
    }

    // Verificar se EmailJS está configurado
    if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
      alert('Serviço de email não configurado. Por favor, entre em contato diretamente.');
      return;
    }

    setIsLoading(true);

    try {
      const templateParams = {
        nome: formData.nome.trim(),
        email: formData.email.trim(),
        telefone: formData.telefone.trim(),
        tipoImovel: formData.tipoImovel,
        situacao: formData.situacao,
        mensagem: formData.mensagem?.trim() || 'Nenhuma mensagem adicional',
        data_envio: new Date().toLocaleString('pt-BR')
      };

      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams
      );

      console.log('Email enviado com sucesso:', response);
      alert('Obrigado! Entraremos em contato em breve para sua análise gratuita!');
      
      setShowModal(false);
      resetForm();

    } catch (error) {
      console.error('Erro ao enviar email:', error);
      alert('Ops! Ocorreu um erro ao enviar sua mensagem. Tente novamente ou entre em contato diretamente.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = () => {
    if (!isLoading) {
      setShowModal(false);
    }
  };

  return (
    <>
      {/* Bootstrap CSS */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      {/* CSS Customizado */}
      <style>{`
        /* Animações */
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        
        .btn-pulse {
          animation: pulse 2s infinite;
        }
        
        .btn-pulse:hover {
          animation-play-state: paused;
        }
        
        /* Background sections */
        .bg-section {
          background-color: rgba(0,0,0,0.2);
        }
        
        .bg-footer {
          background-color: rgba(0,0,0,0.4);
        }
        
        /* Cards customizados */
        .card-custom {
          background-color: rgba(0,0,0,0.5);
          color: white;
          border: none;
          transition: transform 0.3s ease;
        }
        
        .card-custom:hover {
          transform: translateY(-2px);
        }
        
        /* Modal customizado */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        }
        
        .modal-container {
          background: white;
          border-radius: 0.75rem;
          max-width: 500px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 25px 50px rgba(0,0,0,0.25);
        }
        
        .modal-header {
          padding: 1.5rem 1.5rem 1rem 1.5rem;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .modal-title {
          font-size: 1.5rem;
          font-weight: bold;
          color: #0f766e;
          margin: 0;
        }
        
        .btn-close-custom {
          background: none;
          border: none;
          color: #6b7280;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 0.375rem;
          transition: all 0.2s;
        }
        
        .btn-close-custom:hover:not(:disabled) {
          color: #374151;
          background-color: #f3f4f6;
        }
        
        .btn-close-custom:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .modal-body {
          padding: 1rem 1.5rem 1.5rem 1.5rem;
        }
        
        /* Campos do formulário */
        .form-label {
          margin-bottom: 0.5rem;
          color: #374151 !important;
          font-size: 0.875rem;
        }
        
        .form-control-custom {
          border: 2px solid #e5e7eb;
          border-radius: 0.5rem;
          padding: 0.75rem;
          font-size: 1rem;
          transition: all 0.2s;
          color: #1f2937;
          background-color: white;
        }
        
        .form-control-custom:focus {
          border-color: #0f766e;
          box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.1);
          outline: none;
        }
        
        .form-control-custom:disabled {
          background-color: #f9fafb;
          opacity: 0.7;
        }
        
        .form-control-custom.is-invalid {
          border-color: #dc3545;
        }
        
        .invalid-feedback {
          display: block;
          width: 100%;
          margin-top: 0.25rem;
          font-size: 0.875rem;
          color: #dc3545;
        }
        
        /* Botões do formulário */
        .btn-submit {
          background: linear-gradient(135deg, #0f766e 0%, #0d9488 100%) !important;
          border: none !important;
          border-radius: 0.75rem !important;
          transition: all 0.3s !important;
          font-weight: 700 !important;
          letter-spacing: 0.025em !important;
          color: white !important;
        }
        
        .btn-submit:hover:not(:disabled) {
          background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 10px 20px rgba(15, 118, 110, 0.3) !important;
          color: white !important;
        }
        
        .btn-disabled {
          background-color: #9ca3af !important;
          border: none !important;
          color: white !important;
          cursor: not-allowed !important;
          border-radius: 0.75rem !important;
        }
        
        /* Ícones com hover */
        .icon-hover {
          opacity: 0.8;
          transition: opacity 0.3s ease;
        }
        
        .icon-hover:hover {
          opacity: 1;
          cursor: pointer;
        }
        
        /* Responsividade */
        @media (max-width: 768px) {
          .display-4 {
            font-size: 2rem;
          }
          
          .modal-container {
            margin: 1rem;
            max-height: calc(100vh - 2rem);
          }
          
          .modal-header {
            padding: 1rem;
          }
          
          .modal-body {
            padding: 1rem;
          }
        }
        
        @media (max-width: 576px) {
          .display-4 {
            font-size: 1.5rem;
          }
          
          .btn-lg {
            font-size: 1rem !important;
            padding: 0.75rem 1.5rem !important;
          }
        }
      `}</style>
      
      <div className="min-vh-100 text-white" style={{
        background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 50%, #0f766e 100%)'
      }}>
        <Header />
        <HeroSection onOpenModal={() => setShowModal(true)} />
        <ProblemSection onOpenModal={() => setShowModal(true)} />
        <SolutionSection />
        <AuthoritySection />
        <ScarcitySection onOpenModal={() => setShowModal(true)} />
        <ObjectionSection />
        <Footer />
        <WhatsAppFloat />
        
        <Modal 
          show={showModal}
          onClose={() => setShowModal(false)}
          formData={formData}
          onInputChange={handleInputChange}
          onSubmit={handleSubmit}
        />
      </div>
    </>
  );
};

export default LandingPage;